import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import moment from 'moment' // 导入文件
import './permission'
import permission from './directive/permission'
import { getDicts, setDictToInt } from '@/api/system/dict/data'
import {
  Image as VanImage, Search, List, Cell, Button, Tag, Dialog, Area, Toast, Icon, Field, Col, Row, CellGroup, Popup, Picker, Radio, RadioGroup,
  Grid, GridItem, Tab, Uploader, Tabs, Form, Calendar, NavBar, CollapseItem, Collapse, Empty, Divider, Step, Steps, Progress
} from 'vant'
// 加载全样式
import './style/index.less'
import '@/style/fonts/iconfont.css'
import '@/style/fonts/icon.css'
import '@/style/fonts/iconfont.js'
// 动态设置 REM 基准值
import 'amfe-flexible'
import { handleTree, selectDictLabel, toChineseBig, getValue, formaterMoney } from '@/utils/util'
import { preventReClick } from '@/utils/plugins'

import MetaInfo from 'vue-meta-info'

Vue.use(permission)
moment.locale('zh-cn')
Vue.use(Search).use(List).use(Cell).use(Button).use(Tag).use(Dialog).use(Area).use(Toast).use(Icon).use(Field).use(Col)
  .use(Row).use(CellGroup).use(Popup).use(Picker).use(Radio).use(RadioGroup).use(Grid).use(GridItem).use(Tab).use(Uploader)
  .use(Tabs).use(Form).use(Calendar).use(NavBar).use(CollapseItem).use(Collapse).use(Empty).use(Divider).use(Step).use(Steps).use(Progress).use(VanImage)
Vue.use(MetaInfo)
Vue.use(preventReClick)

Vue.prototype.$moment = moment
Vue.prototype.handleTree = handleTree
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.getDicts = getDicts
Vue.prototype.setDictToInt = setDictToInt
Vue.prototype.toChineseBig = toChineseBig
Vue.prototype.getValue = getValue
Vue.prototype.formaterMoney = formaterMoney

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.onload = function() {
  document.addEventListener('gesturestart', function(e) {
    e.preventDefault()
  })
  document.addEventListener('dblclick', function(e) {
    e.preventDefault()
  })
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  var lastTouchEnd = 0
  document.addEventListener(
    'touchend',
    function(event) {
      var now = new Date().getTime()
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    },
    false
  )
}
window.onpageshow = function() {
  const ft = getComputedStyle(window.document.documentElement)['font-size']
  if (+ft.slice(0, ft.length - 2) > 80) {
    document.documentElement.style.fontSize = '37.5px'
  } // 在重新进入页面的时候重新设置rem
}
// console.log(getComputedStyle(window.document.documentElement)['font-size'])
